/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import { LegalEntityTermsAndConditionsTypesEnum } from '../../common/legal-entity-terms-and-conditions-types.enum';

export class LegalEntityTermsAndConditionsCompanyVO extends JSONable {

  uuid: string | undefined = undefined;
  companyName: string | undefined = undefined;
  documentType: LegalEntityTermsAndConditionsTypesEnum | undefined = undefined;
  forLegalEntityUuid: string | undefined = undefined;
}
